import React from "react";

const PrayerTimeTableSkeleton = () => {
  // Create an array of 5 items to represent 5 rows of skeleton data
  const skeletonRows = Array(5).fill(null);

  return (
    <div className="max-w-full mx-auto">
      <div className="mt-8 shadow-sm border border-gray-300 rounded-lg overflow-x-auto">
        <table className="w-full table-auto text-sm text-left">
          <thead className="bg-gray-50 text-gray-600 font-medium border-b border-gray-300">
            <tr>
              <th className="py-3 px-6">Date</th>
              <th className="py-3 px-6">Fajar</th>
              <th className="py-3 px-6">Zuhar</th>
              <th className="py-3 px-6">Asar</th>
              <th className="py-3 px-6">Magrib</th>
              <th className="py-3 px-6">Isha</th>
            </tr>
          </thead>
          <tbody className="text-gray-700 divide-y">
            {skeletonRows.map((_, idx) => (
              <tr key={idx} className="text-[15px]">
                <td className="flex items-center gap-x-3 py-3 px-6 whitespace-nowrap">
                  <div>
                    <span className="block w-32 h-4 bg-gray-200 rounded"></span>
                    <span className="block w-24 h-3 mt-2 bg-gray-200 rounded"></span>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="block w-16 h-4 bg-gray-200 rounded"></span>
                </td>
                <td className="px-6 py-4">
                  <span className="block w-16 h-4 bg-gray-200 rounded"></span>
                </td>
                <td className="px-6 py-4">
                  <span className="block w-16 h-4 bg-gray-200 rounded"></span>
                </td>
                <td className="px-6 py-4">
                  <span className="block w-16 h-4 bg-gray-200 rounded"></span>
                </td>
                <td className="px-6 py-4">
                  <span className="block w-16 h-4 bg-gray-200 rounded"></span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PrayerTimeTableSkeleton;